const data = [
    {name: 'Nootan', uv: 4000, pv: 2400, amt: 2400},
    {name: 'Singh', uv: 3000, pv: 1398, amt: 2210},
    {name: 'SApna', uv: 2000, pv: 9800, amt: 2290},
    {name: 'Singh', uv: 2780, pv: 3908, amt: 2000},
    {name: 'AAA', uv: 1890, pv: 4800, amt: 2181},
    {name: 'VVV', uv: 2390, pv: 3800, amt: 2500},
    {name: 'BBBB', uv: 3490, pv: 4300, amt: 2100},
];
export default data;


// WEBPACK FOOTER //
// ./app/routes/charts/routes/area/Components/data.js